module.exports = __webpack_public_path__ + "static/media/acm logo 1.fc505ea8.png";